import React, { createContext, useContext, useState } from 'react';

export const HeaderSearchContext = createContext<{
  buildingSearch: string;
  setBuildingSearch: (val: string) => void;
  neighborhoodSearch: string;
  setNeighborhoodSearch: (val: string) => void;
  prevNeighborhoodSearch: string;
  setPrevNeighborhoodSearch: (val: string) => void;
}>({
  buildingSearch: '',
  setBuildingSearch: () => {},
  neighborhoodSearch: '',
  setNeighborhoodSearch: () => {},
  prevNeighborhoodSearch: '',
  setPrevNeighborhoodSearch: () => {},
});

const HeaderSearchProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [buildingSearch, setBuildingSearch] = useState('');
  const [neighborhoodSearch, setNeighborhoodSearch] = useState('');
  const [prevNeighborhoodSearch, setPrevNeighborhoodSearch] = useState('');

  return (
    <HeaderSearchContext.Provider
      value={{
        buildingSearch,
        setBuildingSearch,
        neighborhoodSearch,
        setNeighborhoodSearch,
        prevNeighborhoodSearch,
        setPrevNeighborhoodSearch,
      }}
    >
      {children}
    </HeaderSearchContext.Provider>
  );
};

export const useHeaderSearch = () => useContext(HeaderSearchContext);

export default HeaderSearchProvider;
